import * as React from 'react';
const Resources = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <path
            fill="#80B8EE"
            fillRule="evenodd"
            d="M19.5 4.5h-15V9h15V4.5ZM3 4.5V9a1.5 1.5 0 0 0-1.5 1.5v9A1.5 1.5 0 0 0 3 21h18a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 21 9V4.5A1.5 1.5 0 0 0 19.5 3h-15A1.5 1.5 0 0 0 3 4.5Zm1.5 6H21v9H3v-9h1.5Zm6.75 1.5a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5h-1.5Z"
            clipRule="evenodd"
        />
    </svg>
);

export default Resources;
